import { useState, FormEvent } from 'react';
import {
  Box,
  Button,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';

import { RecentCompaniesCard } from './recent-companies-card.component';

/**
 * Company search screen by `companyId`. Renders the hero ("Buscar
 * empresa" + subtitle), the form with TextField + Button, and the
 * `RecentCompaniesCard` underneath. Submit validates non-empty input and
 * navigates to `/company/:companyId` so the URL stays linkable and
 * shareable.
 */
export const CompanySearch = () => {
  const [companyId, setCompanyId] = useState('');
  const navigate = useNavigate();

  const trimmed = companyId.trim();
  const isValid = trimmed.length > 0;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!isValid) {
      return;
    }
    navigate(`/company/${encodeURIComponent(trimmed)}`);
  };

  return (
    <Stack spacing={3} sx={{ maxWidth: 720, mx: 'auto', mt: 6, px: 2 }}>
      <Stack spacing={1} alignItems="center" textAlign="center">
        <Typography variant="h4" component="h1">
          Buscar empresa
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ingresá el companyId para ver suscripción, plan, paquetes y líneas
          HSM.
        </Typography>
      </Stack>

      <Box component="form" onSubmit={handleSubmit}>
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
            placeholder="67ad0808f294c00848de8636"
            fullWidth
            inputProps={{ 'aria-label': 'company-id' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <Button type="submit" variant="contained" disabled={!isValid}>
            Buscar
          </Button>
        </Stack>
      </Box>

      <RecentCompaniesCard />
    </Stack>
  );
};
